<template>
  <div class="bubble-chamber-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>r = mv / (qB) | 荷质比测定$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Tracks -->
          <path v-for="t in tracks" :key="t.id" :d="t.path" fill="none" :stroke="t.color" stroke-width="1.5" :opacity="t.life">
             <animate attributeName="stroke-dashoffset" from="500" to="0" dur="2s" repeatCount="1" />
          </path>
          
          <!-- Background bubbles mock -->
          <circle v-for="n in 50" :key="'b'+n" :cx="Math.random()*400" :cy="Math.random()*240" r="0.5" fill="#fff" opacity="0.2" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>垂直磁场正作用于带电粒子</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <el-button type="primary" size="mini" @click="spawnTrack">捕捉新粒子事件</el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>气泡室（Bubble Chamber）是探测高能粒子的重要设备。在充满过热液体的容器中，带电粒子穿过时会使液体产生微小气泡，形成可见的路径。在强磁场中，路径会根据粒子的电荷性质和动量发生**偏转**（半径 $r$ ）。通过分析螺旋状轨迹，物理学家可以确定粒子的能量、电荷和质量。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BubbleChamberViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      tracks: [],
      timer: null
    }
  },
  methods: {
    spawnTrack() {
       const id = Date.now();
       const startY = Math.random() * 200 + 20;
       const charge = Math.random() > 0.5 ? 1 : -1;
       const radius = Math.random() * 100 + 50;
       const color = charge > 0 ? '#ff4757' : '#00d2ff';
       
       let d = `M 0 ${startY} `;
       for (let i = 0; i < 40; i++) {
          let x = i * 10;
          let y = startY + charge * (Math.sqrt(Math.abs(radius*radius - x*x)) - radius);
          if (isNaN(y)) break;
          d += `L ${x} ${y} `;
       }

       this.tracks.unshift({ id, path: d, color, life: 1 });
       if (this.tracks.length > 5) this.tracks.pop();
    }
  },
  mounted() {
     this.spawnTrack();
  }
}
</script>

<style scoped lang="scss">
.bubble-chamber-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
